// Client-only cookie utilities used by App.js and potentially other UI modules
// These helpers avoid hardcoding domain/path and try multiple candidates for robustness.

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

// Build parent domain candidates from current hostname.
// Example: apps.campus.example.co -> [".campus.example.co", ".example.co", "campus.example.co", "example.co", "apps.campus.example.co"]
export function getDomainCandidates() {
  const host = window.location.hostname || "";
  const parts = host.split(".");
  const parents = [];
  for (let i = 1; i < parts.length; i++) {
    const parent = parts.slice(i).join(".");
    if (parent.split(".").length > 1) parents.push(parent);
  }
  const variants = [];
  parents.forEach((p) => {
    if (p && p.includes(".")) {
      variants.push("." + p);
      variants.push(p);
    }
  });
  if (host) variants.push(host);
  return Array.from(new Set(variants));
}

export function deleteCookieDynamic(name) {
  const expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
  const sameSiteSecure = "; SameSite=None; secure";
  const domainCandidates = getDomainCandidates();
  const pathSegments = (window.location.pathname || "/")
    .split("/")
    .filter(Boolean);
  const dynamicPaths = [
    "/",
    ...pathSegments.map((_, i, arr) => "/" + arr.slice(0, i + 1).join("/")),
  ];
  const pathCandidates = Array.from(
    new Set(["/", "/app", "/dashboard", "/lms", "/courses", ...dynamicPaths])
  );

  // Host-only attempts
  document.cookie = `${name}=; ${expires}; path=/`;
  pathCandidates.forEach((p) => {
    document.cookie = `${name}=; ${expires}; path=${p}`;
    document.cookie = `${name}=; Max-Age=0; path=${p}`;
  });

  // Domain-based attempts
  domainCandidates.forEach((domain) => {
    document.cookie = `${name}=; ${expires}; path=/; domain=${domain}${sameSiteSecure}`;
    document.cookie = `${name}=; ${expires}; path=/; domain=${domain}`;
    document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`;
    pathCandidates.forEach((p) => {
      document.cookie = `${name}=; ${expires}; path=${p}; domain=${domain}${sameSiteSecure}`;
      document.cookie = `${name}=; ${expires}; path=${p}; domain=${domain}`;
      document.cookie = `${name}=; Max-Age=0; path=${p}; domain=${domain}`;
    });
  });
}

export function deleteClientCookies(list) {
  const cookies = list && list.length ? list : ["autenticator_user"];
  cookies.forEach(deleteCookieDynamic);
}
